module.exports = __webpack_public_path__ + "static/media/stem.dfdb63d7.png";